export async function retry(operation, options = {}) {
  const {
    retries = 3,
    delay = 400,
    backoff = 2,
    shouldRetry = defaultShouldRetry,
    onRetry
  } = options;

  let attempt = 0;
  let lastError;

  while (attempt < retries) {
    try {
      return await operation();
    } catch (error) {
      lastError = error;

      if (!shouldRetry(error, attempt)) {
        throw error;
      }

      attempt += 1;
      if (attempt >= retries) {
        break;
      }

      if (typeof onRetry === 'function') {
        onRetry({ error, attempt });
      }

      const timeout = delay * Math.pow(backoff, attempt - 1);
      await new Promise((resolve) => setTimeout(resolve, timeout));
    }
  }

  throw lastError;
}

function defaultShouldRetry(error) {
  if (!error) return false;

  const message = (error.message || error.toString() || '').toLowerCase();

  if (error.name === 'TypeError') {
    return true;
  }

  const transientPatterns = [
    'failed to fetch',
    'networkerror',
    'network request failed',
    'load failed',
    'connection was lost',
    'timeout'
  ];

  return transientPatterns.some((pattern) => message.includes(pattern));
}
